const fileNameFromUrl = (url: string) => {
  return (
    url
      .split("/")
      .pop()
      ?.replace(/\..+/g, "") || ""
  );
};
export default fileNameFromUrl;
